import React from "react";
import { useTranslation } from "react-i18next";

import "./SectionHeader.css";

const SECTION_CONFIG = {
  gestion: {
    icon: "G",
    color: "#2563eb",
  },
  assistant: {
    icon: "AI",
    color: "#14b8a6",
  },
  agent: {
    icon: "A",
    color: "#6366f1",
  },
};

const normalizeLocale = (locale) => {
  const value = String(locale || "").toLowerCase();
  if (value.startsWith("ar")) return "ar";
  if (value.startsWith("en")) return "en";
  return "fr";
};

export default function SectionHeader({
  section = "assistant",
  onBack,
  locale = "fr",
  onLocaleChange,
}) {
  const { t } = useTranslation("assistantAi");
  const config = SECTION_CONFIG[section] || SECTION_CONFIG.assistant;
  const normalizedLocale = normalizeLocale(locale);
  const isRtl = normalizedLocale === "ar";
  const sectionLabel = t(`sectionHeader.sections.${section}.label`, { lng: normalizedLocale });
  const backLabel = t("sectionHeader.back", { lng: normalizedLocale });
  const languageLabel = t("sectionHeader.languageLabel", { lng: normalizedLocale });

  return (
    <header className={`ml-section-header ml-section-header--${section}`} dir={isRtl ? "rtl" : "ltr"}>
      <button type="button" className="ml-section-header__back" onClick={onBack} aria-label={backLabel} title={backLabel}>
        <span aria-hidden="true">{isRtl ? "→" : "←"}</span>
      </button>

      <div className="ml-section-header__identity">
        <span className="ml-section-header__icon" style={{ backgroundColor: config.color }} aria-hidden="true">
          {config.icon}
        </span>
        <span>{sectionLabel} MediLink</span>
      </div>

      {onLocaleChange && (
        <div className="ml-section-header__langs" role="group" aria-label={languageLabel}>
          {["fr", "en", "ar"].map((lang) => (
            <button
              key={lang}
              type="button"
              className={locale === lang ? "is-active" : ""}
              onClick={() => onLocaleChange(lang)}
              aria-pressed={locale === lang}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
